import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { PropertyCollection, ResultReason, SynthesisResult, VoiceInfo } from "./Exports";
/**
 * Defines result of speech synthesis.
 * @class SynthesisVoicesResult
 * Added in version 1.20.0
 */

export var SynthesisVoicesResult = /*#__PURE__*/function (_SynthesisResult) {
  _inherits(SynthesisVoicesResult, _SynthesisResult);

  var _super = _createSuper(SynthesisVoicesResult);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param requestId - result id for request.
   * @param json - json payload from endpoint.
   */
  function SynthesisVoicesResult(requestId, json) {
    var _this;

    _classCallCheck(this, SynthesisVoicesResult);

    if (Array.isArray(json)) {
      _this = _super.call(this, requestId, ResultReason.VoicesListRetrieved, undefined, new PropertyCollection());
      _this.privVoices = [];

      var _iterator = _createForOfIteratorHelper(json),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          _this.privVoices.push(new VoiceInfo(item));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      _this = _super.call(this, requestId, ResultReason.Canceled, !!json.errorDetails ? json.errorDetails : "Error information unavailable", new PropertyCollection());
    }

    return _possibleConstructorReturn(_this);
  }
  /**
   * The list of voices
   * @member SynthesisVoicesResult.prototype.voices
   * @function
   * @public
   * @returns {VoiceInfo[]} List of synthesized voices.
   */


  _createClass(SynthesisVoicesResult, [{
    key: "voices",
    get: function get() {
      return this.privVoices;
    }
  }]);

  return SynthesisVoicesResult;
}(SynthesisResult);